import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import EditableListTab from 'components/editable-list-tab';
import st from 'core/shared-translations';

const t = defineMessages({
  'client-edit.field.roles': {
    id: 'client-edit.field.roles',
    defaultMessage: 'Role ID',
    description: 'Label for the Role ID field',
  },
  'client-edit.field.roles.placeholder': {
    id: 'client-edit.field.roles.placeholder',
    defaultMessage: 'Enter role ID',
    description: 'Placeholder for the Role ID field',
  },
});

const ClientRolesTab = ({
  client,
  canWrite,
  roles = [],
  onAddRole,
  onDeleteRole,
  scopeValidationErrors,
  clearScopeError
}) => {
  const translations = {
    fieldLabel: t['client-edit.field.roles'],
    fieldPlaceholder: t['client-edit.field.roles.placeholder'],
    addButtonText: st['shared.add']
  };

  return (
    <EditableListTab
      client={client}
      canWrite={canWrite}
      items={roles}
      onAddItem={onAddRole}
      onDeleteItem={onDeleteRole}
      translations={translations}
      validationErrors={scopeValidationErrors}
      clearScopeError={clearScopeError}
    />
  );
};

ClientRolesTab.propTypes = {
  client: PropTypes.object.isRequired,
  canWrite: PropTypes.bool.isRequired,
  roles: PropTypes.array,
  onAddRole: PropTypes.func.isRequired,
  onDeleteRole: PropTypes.func.isRequired,
  scopeValidationErrors: PropTypes.string,
  clearScopeError: PropTypes.func.isRequired,
};

export default ClientRolesTab;